import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import { useQuery, } from "react-query";
import { getUsersEntireData } from '../../../functions/apis';
import { connect } from "react-redux";
import { handleGetEntireUserDataResume } from '../../../services/actions/actions';
import ServerError from '../../../Pages/error/500/ServerError';
import Loading from '../../../Loading/Loading';

function Resume({resumeReducer, component,getEntireUserDataResume }) {
  console.log(resumeReducer)
  const { isError, isLoading, isSuccess, error } = useQuery('userEntireData', getUsersEntireData, { refetchOnWindowFocus: false, onSuccess: data => { getEntireUserDataResume(data[0]) } })
  useEffect(() => {
    localStorage.setItem("state", JSON.stringify(resumeReducer))
  },[resumeReducer])
  if (isLoading) return <><div className="flex items-center justify-center h-screen"><Loading className={'w-48'} /></div></>;
  if (isError) return <><div><ServerError message={error.response.status} /></div></>
  if(isSuccess) return (
    <>
        <div className=' max-w-6xl mx-auto hidden xl:block'>
          <div className='mt-20'>
            <Layout view={component} />
          </div>
        </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    getEntireUserDataResume: (value) => {
      dispatch(handleGetEntireUserDataResume(value))
    },
  }
}
export default connect(mapStateToProps,mapDispatchToState)(Resume)